export const WA_CATALOG_MESSAGE_MAX_BODY_LENGTH = 1024
export const WA_CATALOG_MESSAGE_MAX_FOOTER_LENGTH = 60
